import {
    faArrowRight,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    CadastrarAcaoEtapaController,
    DeletarAcaoEtapaController,
    ListarAcaoEtapaController,
} from "../../../../../../../../../../Controllers/Geral/AcaoEtapa/AcaoEtapaControllers";
import { IAcaoEtapa } from "../../../../../../../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import { IEtapa } from "../../../../../../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import Table from "../../../../../../../../../Table";

interface IAcoesEtapaProps {
    idEtapa: number;
    lstEtapas: Array<IEtapa>;
}

export default function AcoesEtapa(props: IAcoesEtapaProps) {
    const { register, handleSubmit, formState, watch } = useForm<IAcaoEtapa>();
    const watcherTipoAcao = watch(
        "DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
    );

    const [lstAcoes, setLstAcoes] = useState<Array<IAcaoEtapa>>([]);

    const updateAcoes = useCallback(() => {
        ListarAcaoEtapaController(props.idEtapa)
            .then((res) => res.ACOES_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO)
            .then(setLstAcoes);
    }, [props.idEtapa]);

    function handleAcaoEtapaFormSubmit(formData: IAcaoEtapa) {
        CadastrarAcaoEtapaController({
            ...formData,
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: props.idEtapa,
        }).then(updateAcoes);
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO",
            text: "Ações da Etapa",
            formatter: (cell, row) => <RowFormatter {...row} />,
        },
    ];
    function RowFormatter(row: IAcaoEtapa) {
        return (
            <div className="p-2 d-flex justify-content-between">
                <div>
                    <h4>{row.DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}</h4>
                    <div className="d-flex flex-wrap">
                        <span className="label abel-pill label-inline label-info m-1">
                            {
                                row.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                        </span>

                        {row.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_DESTINO ? (
                            <span className="label abel-pill label-inline label-primary m-1">
                                <FontAwesomeIcon
                                    icon={faArrowRight}
                                    className="mr-2"
                                />
                                {
                                    row.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_DESTINO
                                }
                            </span>
                        ) : null}

                        {row.FL_INSERIR_JUSTIFICATIVA_FECHAMENTO_CASO ? (
                            <span className="label abel-pill label-inline label-warning m-1">
                                Justificativa necessária
                            </span>
                        ) : null}
                    </div>
                </div>
                <div>
                    <button
                        className="btn btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja deletar esta ação?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarAcaoEtapaController(
                                        row.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                    ).then(updateAcoes);
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            </div>
        );
    }

    useEffect(() => {
        updateAcoes();
    }, [updateAcoes]);

    return (
        <div>
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-success mb-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseNovaAcao"
                    aria-expanded="false"
                    aria-controls="collapseNovaAcao"
                >
                    <FontAwesomeIcon icon={faPlus} size="lg" className="mr-2" />{" "}
                    Novo
                </button>
            </div>

            <div className="collapse mb-5" id="collapseNovaAcao">
                <h5 className="text-center">Cadastro de Ação</h5>
                <form
                    onSubmit={handleSubmit(handleAcaoEtapaFormSubmit)}
                    className="w-100 align-itens-center"
                >
                    <div className="row mb-3">
                        <div className="col-12 col-lg-6">
                            <label>Nome da Ação</label>
                            <input
                                type="text"
                                name="DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors
                                        .DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required: "Insira o Nome da Ação",
                                })}
                            />
                        </div>
                        <div className="col-12 col-lg-6">
                            <label>Tipo de Ação</label>
                            <select
                                name="DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors
                                        .DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required: "Insira o Tipo de Ação",
                                })}
                            >
                                <option>CANCELAR CASO</option>
                                <option>ABRIR CASO</option>
                                <option>IR PARA ETAPA</option>
                                <option>FINALIZAR CASO</option>
                            </select>
                        </div>
                        <div className="col-12 col-lg-6">
                            <label>Etapa Destino</label>
                            <select
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO_DESTINO"
                                className={`form-control placeholder-dark-50`}
                                ref={register()}
                            >
                                <option></option>
                                {props.lstEtapas.map((etapa) => (
                                    <option
                                        value={
                                            etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                        key={
                                            etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    >
                                        {
                                            etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    </option>
                                ))}
                            </select>
                        </div>
                        {watcherTipoAcao === "FINALIZAR CASO" && (
                            <div className="col-12 col-md-6 mt-2 d-flex flex-column align-itens-center justify-content-center">
                                <div className="text-center font-weight-bold">
                                    Incluir justificativa de fechamento :
                                </div>
                                <span
                                    className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                                    data-toggle="tooltip"
                                >
                                    <label>
                                        <input
                                            id="FL_INSERIR_JUSTIFICATIVA_FECHAMENTO_CASO_STATUS"
                                            name="FL_INSERIR_JUSTIFICATIVA_FECHAMENTO_CASO"
                                            defaultChecked={false}
                                            ref={register()}
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        )}
                        <div className="col-12 d-flex align-items-end mt-3">
                            <button className="btn btn-outline-success font-weight-bold justify-content-center d-flex w-100 ">
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Cadastrar
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <Table
                keyField="ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                columns={columns}
                data={lstAcoes}
                noDataIndication={
                    <div className="text-center text-muted">
                        Nenhuma ação cadastrada
                    </div>
                }
            />
        </div>
    );
}
